import * as URLParamHelpers from "@unibuddy/machop/Utils/UrlUtils";
import mixpanelAdaptor from "@unibuddy/machop/AnalyticsNew/AnalyticsProvider/Adaptors/mixpanelAdaptor";
import Intl, {Constants, I18nextEngine} from "@unibuddy/intl";
import mixpanel from "mixpanel-browser";
import React from "react";
import {hot} from "react-hot-loader/root";
import "whatwg-fetch";
import ResizeObserver from "resize-observer-polyfill";
import {BrowserRouter} from "react-router-dom";
import get from "lodash/get";
import "normalize.css";
import Pusher from "pusher-js";
import ErrorBoundary from "@unibuddy/machop/General/components/ErrorBoundary/ErrorBoundary";
import {config} from "@unibuddy/machop/ConfigManager/ConfigManager";
import ErrorReportingProvider from "@unibuddy/machop/General/components/ErrorReporting/ErrorReportingProvider";
import {
    apps,
    initErrorReportingService,
    errorReportingAdaptor,
} from "@unibuddy/machop/General/components/ErrorReporting/errorReportingAdaptor";
import {COOKIE_CATEGORIES, MIXPANEL} from "@unibuddy/machop/Utils/Constants";
import AnalyticsValue from "@unibuddy/machop/AnalyticsNew/AnalyticsValue/AnalyticsValue";
import UniversalAnalyticsProvider from "@unibuddy/machop/AnalyticsNew/AnalyticsProvider/UniversalAnalyticsProvider";
import SourceTrackingProvider from "@unibuddy/machop/SourceTracking/SourceTrackingProvider/SourceTrackingProvider";
import {productSpec} from "@unibuddy/machop/AnalyticsNew/constants/productSpecification";
import BuddiesFiltersProvider from "@unibuddy/machop/Buddies/components/BuddiesFiltersProvider/BuddiesFiltersProvider";
import Navigation from "./Navigation/components/Navigation/Navigation";
import AuthProvider from "./Auth/components/AuthProvider/AuthProvider";
import MessengerProvider from "./Messenger/components/MessengerProvider/MessengerProvider";
import onAuthChange from "./Auth/functions/onAuthChange";
import AppRoutes from "./AppRoutes";
import ApiProvider from "./ApiProvider";
import analyticsProductSpecification from "./analyticsProductSpecification";
import "./App.css";

// Initialise Sentry
initErrorReportingService({app: apps.UCAS});

// Initialise i18next
const options = {
    appName: Constants.APP_NAMES.DISCOVER,
    lng: URLParamHelpers.getParameterByName(window.location.href, "ub_lang"),
    translationsUrl: config.TRANSLATIONS_URL,
};

const i18nextEngine = new I18nextEngine(options);

const analyticsAdaptors = [];

const SetProduct = () => {
    return (
        <React.Fragment>
            <AnalyticsValue
                name={productSpec.ucas.properties.PRODUCT}
                value={productSpec.ucas.NAME}
            />
        </React.Fragment>
    );
};
export const SetMixpanel = (url, adaptor) => {
    const path = URLParamHelpers.getParameterByName(url, "ub_cookie_consent");
    if (path) {
        const preferences = path.split(" ");
        let mixpanelInit = false;
        preferences.forEach(preference => {
            if (preference) {
                const key = preference.trim().toLowerCase();
                if (
                    !mixpanelInit &&
                    COOKIE_CATEGORIES.has(key) &&
                    COOKIE_CATEGORIES.get(key).includes(MIXPANEL)
                ) {
                    mixpanel.init(config.MIXPANEL_ID, {
                        api_host: config.MIXPANEL_PROXY_HOST,
                    });
                    adaptor.push(mixpanelAdaptor);
                    mixpanelInit = true;
                }
            }
        });
    }
};

// eslint-disable-next-line react/prefer-stateless-function
export class AppComponent extends React.Component {
    componentDidMount = () => {
        if (matchMedia("(min-width: 1024px)").matches) {
            this.resizeObserver = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    this.height = entry.contentRect.height;
                    this.onResize();
                });
            });
            this.resizeObserver.observe(document.querySelector("main"));
        }
    };

    componentWillUnmount = () => {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    };

    componentWillMount = () => {
        SetMixpanel(window.location.toString(), analyticsAdaptors);
    };

    onResize = () => {
        window.parent.postMessage(
            {
                type: "onResize",
                height: this.height,
            },
            "*",
        );
    };

    render() {
        return (
            <ErrorReportingProvider adaptor={errorReportingAdaptor}>
                <ErrorBoundary>
                    <BrowserRouter>
                        <AuthProvider onAuthChange={onAuthChange}>
                            <AuthProvider.Context.Consumer>
                                {({authState}) => (
                                    <UniversalAnalyticsProvider
                                        productEvents={analyticsProductSpecification.events}
                                        adaptors={analyticsAdaptors}
                                        user={get(authState, "me.anyUser")}
                                    >
                                        <SourceTrackingProvider
                                            params={{
                                                ub_medium: "product",
                                                ub_source: productSpec.ucas.NAME,
                                            }}
                                        >
                                            <ApiProvider>
                                                <MessengerProvider pusher={Pusher}>
                                                    <BuddiesFiltersProvider>
                                                        <main className="App__main">
                                            <Intl
                                                        engine={i18nextEngine}
                                                        crowdinProjectName={
                                                            Constants
                                                                .CROWDIN_PROJECT_NAMES
                                                                .DISCOVER
                                                        }
                                            >
                                                            <SetProduct />
                                                            <Navigation
                                                                user={get(authState, "me.anyUser")}
                                                            />
                                                            <AppRoutes />
                                                </Intl>
                                                        </main>
                                                    </BuddiesFiltersProvider>
                                                </MessengerProvider>
                                            </ApiProvider>
                                        </SourceTrackingProvider>
                                    </UniversalAnalyticsProvider>
                                )}
                            </AuthProvider.Context.Consumer>
                        </AuthProvider>
                    </BrowserRouter>
                </ErrorBoundary>
            </ErrorReportingProvider>
        );
    }
}

export default hot(AppComponent);
